import React from 'react';
import { EGTMTags } from '../../../../store/commomTypes';
import { DownloadIcon, ErrorIcon } from './styles';
import { Button } from '@gerdau/hefesto/Button';

interface IDownloadCellContentProps {
  onclick(e: React.MouseEvent<HTMLElement>): void;
  loading: boolean;
  error: boolean;
  justifyContent: 'flex-start' | 'center';
  textToShow?: string;
  gtmClassName?: EGTMTags;
  disabled?: boolean;
}

const DownloadCellContent: React.FC<IDownloadCellContentProps> = ({
  onclick,
  loading,
  error,
  textToShow,
  disabled = false
}) => {
  return (
    <Button
      name="download-btn"
      onClick={!disabled ? onclick : undefined}
      variant="secondary"
      loading={loading}
    >
      {!loading && !error && (
        <>
          {!disabled && <DownloadIcon />}
          {textToShow ? textToShow : 'Baixar'}
        </>
      )}

      {loading && <>Baixando</>}

      {error && !loading && (
        <>
          <ErrorIcon />
          {textToShow && (
            <>
              {textToShow}
              <br />
            </>
          )}
          Tentar novamente
        </>
      )}
    </Button>
  );
};

export default DownloadCellContent;
